var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bt-anggota pa-5"},[_c('KelompokWakaf',{attrs:{"target":"transaksi/dashboard","list":_vm.list,"total_wakaf":_vm.total_wakaf,"is_show_total_wakaf":true},on:{"refreshKelompok":_vm.getKelompokWakaf}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }